import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ISupplierDashboardStats,
  SupplierDashboardState,
} from "../../../types/dashboard/supplierDashboardInterfaces";

// ✅ Estado inicial
const initialState: SupplierDashboardState = {
  stats: {
    totalSuppliers: 0,
    activeSuppliers: 0,
    inactiveSuppliers: 0,
    suppliersByEntityType: {},
    suppliersByTaxpayerCategory: {},
    suppliersByEconomicActivity: {},
    suppliersByDistrict: {},
  },
};

export const supplierDashboardSlice = createSlice({
  name: "supplierDashboard",
  initialState,
  reducers: {
    /**
     * ✅ Carga las estadísticas correctamente.
     */
    setStats: (state, action: PayloadAction<ISupplierDashboardStats>) => {
      state.stats = action.payload;
    },

    /**
     * 🔄 Permite limpiar el estado si se requiere.
     */
    clearStats: (state) => {
      state.stats = {
        totalSuppliers: 0,
        activeSuppliers: 0,
        inactiveSuppliers: 0,
        suppliersByEntityType: {},
        suppliersByTaxpayerCategory: {},
        suppliersByEconomicActivity: {},
        suppliersByDistrict: {},
      };
    },
  },
});

export const { setStats, clearStats } = supplierDashboardSlice.actions;
export default supplierDashboardSlice.reducer;
